import { defineMessages } from 'react-intl'

const scope = `procurify.components.MyCardsSelect`

export default defineMessages({
  placeholderText: {
    id: `${scope}.placeholderText`,
    defaultMessage: 'Select a card',
  },
})
